module.exports = __webpack_public_path__ + "img/LUB00374.e3b21449.svg";